import { RQAPICallWithData } from 'store/APIClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CreateChartTemplateDataT } from '../../types';
import { useDispatch } from 'store/hooks';

const createChartTemplate = async (
    chartTemplateData: CreateChartTemplateDataT,
): Promise<{ message: string }> => {
    const response = await RQAPICallWithData({
        endpoint: 'support/chart_templates',
        body: chartTemplateData,
        method: 'POST',
    });
    return response.content;
};

export const useCreateChartTemplate = (
    chartTemplateData: CreateChartTemplateDataT,
) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    return useMutation({
        mutationKey: ['create-indicator-template'],
        mutationFn: () => createChartTemplate(chartTemplateData),
        meta: { useGlobalOnError: true },
        onSuccess: ({ message }) => {
            queryClient.invalidateQueries({
                queryKey: ['chart-templates-table-items'],
            });
            dispatch.vision.notifyUser({
                message,
                snackType: 'success',
            });
        },
    });
};
